import React from 'react';
import PropTypes from 'prop-types';

import { Text } from '@zillow/constellation';

import { StyledHR } from '../postingPath/UtilsStyledComponents';

const propTypes = {
    children: PropTypes.node.isRequired,
};

const DuplicateListingDetailsContainer = ({
    children,
}) => (
    <div className="DuplicateListingDetails">
        <Text
            fontType="h4"
            as="div"
            marginBottom="xs"
            mediaQuery={{ lg: { marginBottom: 'sm' } }}
        >
            Additional listing sources
        </Text>
        {children}
        <StyledHR marginY="md" marginX={0} />
    </div>
);

DuplicateListingDetailsContainer.propTypes = propTypes;

export default DuplicateListingDetailsContainer;
